namespace RioERP.Orders {
    export interface OrderProductBillingItemsTaxRow {
        Id?: number;
        OrderId?: number;
        OrderProductsId?: number;
        TaxTypeId?: number;
        Rate?: number;
        TaxAmount?: number;
        IsActive?: boolean;
        OrderProductBillingItemsId?: number;
        OrderCustomerId?: number;
        OrderOrderNumber?: string;
        OrderCustomerName?: string;
        OrderCustomerEmail1?: string;
        OrderCustomerEmail2?: string;
        OrderCustomerMobile1?: string;
        OrderCustomerMobile2?: string;
        OrderBillingAddress1?: string;
        OrderBillingAddress2?: string;
        OrderBillingCity?: string;
        OrderBillingStateId?: number;
        OrderBillingPincode?: number;
        OrderShippingToName?: string;
        OrderShippingAddress1?: string;
        OrderShippingAddress2?: string;
        OrderShippingCity?: string;
        OrderShippingStateId?: number;
        OrderShippingPincode?: number;
        OrderEOrderStatus?: number;
        OrderEShippingType?: number;
        OrderDiscountPer?: number;
        OrderOrderDate?: string;
        OrderESourceType?: number;
        OrderSourceName?: string;
        OrderEmailSendCount?: number;
        OrderIsEmailSent?: boolean;
        OrderEPaymentStatus?: number;
        OrderLastEmailSentDate?: string;
        OrderFranchiseeId?: number;
        OrderEOrderProcessBy?: number;
        OrderDiscountCoupon?: string;
        OrderDiscountAmount?: number;
        OrderGrossAmount?: number;
        OrderNetAmount?: number;
        OrderTaxableAmount?: number;
        OrderEShippingStatus?: number;
        OrderEInvoiceStatus?: number;
        OrderMailId?: number;
        OrderEPaymentType?: number;
        OrderGstin?: string;
        OrderExpectedShippingDate?: string;
        OrderEInvoiceTo?: number;
        OrderEFranchiseeDiscountType?: number;
        OrderEFranchiseeDiscount?: number;
        OrderFranchiseeDiscountValue?: number;
        OrderFranchiseeDiscountAmount?: number;
        OrderInvoiceCompanyId?: number;
        OrderShippingNote?: string;
        OrderSourceOrderNumber?: string;
        OrderIsActive?: boolean;
        OrderInsertUserId?: number;
        OrderInsertDate?: string;
        OrderUpdateUserId?: number;
        OrderUpdateDate?: string;
        OrderVendorId?: number;
        OrderProductsOrderId?: number;
        OrderProductsProductId?: number;
        OrderProductsQuantity?: number;
        OrderProductsCost?: number;
        OrderProductsGrossAmount?: number;
        OrderProductsDiscountAmt?: number;
        OrderProductsNetAmount?: number;
        OrderProductsTaxableAmount?: number;
        OrderProductsSerialKey?: string;
        OrderProductsHasPendrive?: boolean;
        OrderProductsHasBooks?: boolean;
        OrderProductsHasCourier?: boolean;
        OrderProductsDownloadUrl1?: string;
        OrderProductsDownloadUrl2?: string;
        OrderProductsIsActive?: boolean;
        OrderProductsInvoiceCompanyId?: number;
        OrderProductsFranchiseeDiscountAmount?: number;
        OrderProductsFranchiseeDiscountValue?: number;
        OrderProductsEFranchiseeDiscountType?: number;
        OrderProductsEOpens?: number;
        OrderProductsEWatchTime?: number;
        OrderProductsEValidity?: number;
        OrderProductsEValidityType?: number;
        OrderProductsValidTill?: string;
        OrderProductsTotalAllowedDuration?: number;
        OrderProductsAllowedDevices?: string;
        OrderProductsIsLive?: boolean;
        OrderProductsEAccessStatus?: number;
        OrderProductsIsTemplateSerialKey?: boolean;
        OrderProductsInsertUserId?: number;
        OrderProductsInsertDate?: string;
        OrderProductsUpdateUserId?: number;
        OrderProductsUpdateDate?: string;
        OrderProductsNote?: string;
        OrderProductsESerialkeyStatus?: number;
        TaxTypeName?: string;
        OrderProductBillingItemsOrderId?: number;
        OrderProductBillingItemsOrderProductsId?: number;
        OrderProductBillingItemsGrossAmount?: number;
        OrderProductBillingItemsDiscountAmount?: number;
        OrderProductBillingItemsNetAmount?: number;
        OrderProductBillingItemsTaxCategoryId?: number;
        OrderProductBillingItemsProductBillingItemId?: number;
        OrderProductBillingItemsInvoiceCompanyId?: number;
        OrderProductBillingItemsIsActive?: boolean;
        OrderProductBillingItemsInsertUserId?: number;
        OrderProductBillingItemsInsertDate?: string;
        OrderProductBillingItemsUpdateUserId?: number;
        OrderProductBillingItemsUpdateDate?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace OrderProductBillingItemsTaxRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Orders.OrderProductBillingItemsTax';
        export const deletePermission = 'Orders:OrdersManagement:Modify';
        export const insertPermission = 'Orders:OrdersManagement:Modify';
        export const readPermission = 'Orders:OrdersManagement:View';
        export const updatePermission = 'Orders:OrdersManagement:Modify';

        export declare const enum Fields {
            Id = "Id",
            OrderId = "OrderId",
            OrderProductsId = "OrderProductsId",
            TaxTypeId = "TaxTypeId",
            Rate = "Rate",
            TaxAmount = "TaxAmount",
            IsActive = "IsActive",
            OrderProductBillingItemsId = "OrderProductBillingItemsId",
            OrderCustomerId = "OrderCustomerId",
            OrderOrderNumber = "OrderOrderNumber",
            OrderCustomerName = "OrderCustomerName",
            OrderCustomerEmail1 = "OrderCustomerEmail1",
            OrderCustomerEmail2 = "OrderCustomerEmail2",
            OrderCustomerMobile1 = "OrderCustomerMobile1",
            OrderCustomerMobile2 = "OrderCustomerMobile2",
            OrderBillingAddress1 = "OrderBillingAddress1",
            OrderBillingAddress2 = "OrderBillingAddress2",
            OrderBillingCity = "OrderBillingCity",
            OrderBillingStateId = "OrderBillingStateId",
            OrderBillingPincode = "OrderBillingPincode",
            OrderShippingToName = "OrderShippingToName",
            OrderShippingAddress1 = "OrderShippingAddress1",
            OrderShippingAddress2 = "OrderShippingAddress2",
            OrderShippingCity = "OrderShippingCity",
            OrderShippingStateId = "OrderShippingStateId",
            OrderShippingPincode = "OrderShippingPincode",
            OrderEOrderStatus = "OrderEOrderStatus",
            OrderEShippingType = "OrderEShippingType",
            OrderDiscountPer = "OrderDiscountPer",
            OrderOrderDate = "OrderOrderDate",
            OrderESourceType = "OrderESourceType",
            OrderSourceName = "OrderSourceName",
            OrderEmailSendCount = "OrderEmailSendCount",
            OrderIsEmailSent = "OrderIsEmailSent",
            OrderEPaymentStatus = "OrderEPaymentStatus",
            OrderLastEmailSentDate = "OrderLastEmailSentDate",
            OrderFranchiseeId = "OrderFranchiseeId",
            OrderEOrderProcessBy = "OrderEOrderProcessBy",
            OrderDiscountCoupon = "OrderDiscountCoupon",
            OrderDiscountAmount = "OrderDiscountAmount",
            OrderGrossAmount = "OrderGrossAmount",
            OrderNetAmount = "OrderNetAmount",
            OrderTaxableAmount = "OrderTaxableAmount",
            OrderEShippingStatus = "OrderEShippingStatus",
            OrderEInvoiceStatus = "OrderEInvoiceStatus",
            OrderMailId = "OrderMailId",
            OrderEPaymentType = "OrderEPaymentType",
            OrderGstin = "OrderGstin",
            OrderExpectedShippingDate = "OrderExpectedShippingDate",
            OrderEInvoiceTo = "OrderEInvoiceTo",
            OrderEFranchiseeDiscountType = "OrderEFranchiseeDiscountType",
            OrderEFranchiseeDiscount = "OrderEFranchiseeDiscount",
            OrderFranchiseeDiscountValue = "OrderFranchiseeDiscountValue",
            OrderFranchiseeDiscountAmount = "OrderFranchiseeDiscountAmount",
            OrderInvoiceCompanyId = "OrderInvoiceCompanyId",
            OrderShippingNote = "OrderShippingNote",
            OrderSourceOrderNumber = "OrderSourceOrderNumber",
            OrderIsActive = "OrderIsActive",
            OrderInsertUserId = "OrderInsertUserId",
            OrderInsertDate = "OrderInsertDate",
            OrderUpdateUserId = "OrderUpdateUserId",
            OrderUpdateDate = "OrderUpdateDate",
            OrderVendorId = "OrderVendorId",
            OrderProductsOrderId = "OrderProductsOrderId",
            OrderProductsProductId = "OrderProductsProductId",
            OrderProductsQuantity = "OrderProductsQuantity",
            OrderProductsCost = "OrderProductsCost",
            OrderProductsGrossAmount = "OrderProductsGrossAmount",
            OrderProductsDiscountAmt = "OrderProductsDiscountAmt",
            OrderProductsNetAmount = "OrderProductsNetAmount",
            OrderProductsTaxableAmount = "OrderProductsTaxableAmount",
            OrderProductsSerialKey = "OrderProductsSerialKey",
            OrderProductsHasPendrive = "OrderProductsHasPendrive",
            OrderProductsHasBooks = "OrderProductsHasBooks",
            OrderProductsHasCourier = "OrderProductsHasCourier",
            OrderProductsDownloadUrl1 = "OrderProductsDownloadUrl1",
            OrderProductsDownloadUrl2 = "OrderProductsDownloadUrl2",
            OrderProductsIsActive = "OrderProductsIsActive",
            OrderProductsInvoiceCompanyId = "OrderProductsInvoiceCompanyId",
            OrderProductsFranchiseeDiscountAmount = "OrderProductsFranchiseeDiscountAmount",
            OrderProductsFranchiseeDiscountValue = "OrderProductsFranchiseeDiscountValue",
            OrderProductsEFranchiseeDiscountType = "OrderProductsEFranchiseeDiscountType",
            OrderProductsEOpens = "OrderProductsEOpens",
            OrderProductsEWatchTime = "OrderProductsEWatchTime",
            OrderProductsEValidity = "OrderProductsEValidity",
            OrderProductsEValidityType = "OrderProductsEValidityType",
            OrderProductsValidTill = "OrderProductsValidTill",
            OrderProductsTotalAllowedDuration = "OrderProductsTotalAllowedDuration",
            OrderProductsAllowedDevices = "OrderProductsAllowedDevices",
            OrderProductsIsLive = "OrderProductsIsLive",
            OrderProductsEAccessStatus = "OrderProductsEAccessStatus",
            OrderProductsIsTemplateSerialKey = "OrderProductsIsTemplateSerialKey",
            OrderProductsInsertUserId = "OrderProductsInsertUserId",
            OrderProductsInsertDate = "OrderProductsInsertDate",
            OrderProductsUpdateUserId = "OrderProductsUpdateUserId",
            OrderProductsUpdateDate = "OrderProductsUpdateDate",
            OrderProductsNote = "OrderProductsNote",
            OrderProductsESerialkeyStatus = "OrderProductsESerialkeyStatus",
            TaxTypeName = "TaxTypeName",
            OrderProductBillingItemsOrderId = "OrderProductBillingItemsOrderId",
            OrderProductBillingItemsOrderProductsId = "OrderProductBillingItemsOrderProductsId",
            OrderProductBillingItemsGrossAmount = "OrderProductBillingItemsGrossAmount",
            OrderProductBillingItemsDiscountAmount = "OrderProductBillingItemsDiscountAmount",
            OrderProductBillingItemsNetAmount = "OrderProductBillingItemsNetAmount",
            OrderProductBillingItemsTaxCategoryId = "OrderProductBillingItemsTaxCategoryId",
            OrderProductBillingItemsProductBillingItemId = "OrderProductBillingItemsProductBillingItemId",
            OrderProductBillingItemsInvoiceCompanyId = "OrderProductBillingItemsInvoiceCompanyId",
            OrderProductBillingItemsIsActive = "OrderProductBillingItemsIsActive",
            OrderProductBillingItemsInsertUserId = "OrderProductBillingItemsInsertUserId",
            OrderProductBillingItemsInsertDate = "OrderProductBillingItemsInsertDate",
            OrderProductBillingItemsUpdateUserId = "OrderProductBillingItemsUpdateUserId",
            OrderProductBillingItemsUpdateDate = "OrderProductBillingItemsUpdateDate",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
